import React, { useState, useEffect } from 'react';

import api from '@api';
import { View, Icon } from '@components';
import { renderSomethingWentWrong } from '@utils';
import { Subtitle } from '@components/Styled';
import { useRequest } from '@hooks';

import AccountStatement from './components/AccountStatement';
import MyMovementsDataTable from './components/MyMovementsDataTable/MyMovementsDataTable';
import { MyMovementsDataTableContainer, MyMovementsHeaderContainer } from './MyMovements.style';

const MyMovements = () => {
  const [movements, setMovements] = useState([]);
  const [accountStatementDates, setAccountStatementDates] = useState([]);

  const [movementsResponse, , movementsError, fetchMovements] = useRequest(
    () => api.get('/traders/me/movements')
  );
  const [
    accountStatementDatesResponse, ,
    accountStatementDatesError,
    fetchAccountStatementDates
  ] = useRequest(() => api.get('/traders/me/accountStatementDates'));

  useEffect(() => {
    fetchAccountStatementDates();
    fetchMovements();
  }, []);

  useEffect(() => {
    if (movementsResponse) {
      setMovements(movementsResponse?.data?.movements);
    }
  }, [movementsResponse]);

  useEffect(() => {
    if (movementsError) {
      setMovements([]);
      renderSomethingWentWrong();
    }
  }, [movementsError]);

  useEffect(() => {
    if (accountStatementDatesResponse) {
      setAccountStatementDates(accountStatementDatesResponse.data);
    }
  }, [accountStatementDatesResponse]);

  useEffect(() => {
    if (accountStatementDatesError) {
      setAccountStatementDates([]);
      renderSomethingWentWrong();
    }
  }, [accountStatementDatesError]);

  return (
    <View id="my-movements" title="100 Ladrillos - Mis movimientos">
      <AccountStatement dates={accountStatementDates} />

      <MyMovementsHeaderContainer>
        <Icon name="icMyMovementsActive" alt="icMyMovementsActive" />

        <Subtitle>Mis movimientos</Subtitle>
      </MyMovementsHeaderContainer>

      <MyMovementsDataTableContainer>
        <MyMovementsDataTable movements={movements} />
      </MyMovementsDataTableContainer>
    </View>
  );
};

export default MyMovements;
